import { IDongBoCongNoSinhVien } from "./../../../model/respone/dong-bo/IDongBoCongNoSinhVien";
import { IDongBoCongNoRequest } from "./../../../model/request/dong-bo/IDongBoCongNoRequest";
import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const edongBoCongNoActionsObj = {
  LOAD_START: {} as IDongBoCongNoRequest,
  LOAD_SUCCESS: {} as IDongBoCongNoSinhVien[],
  LOAD_ERRR: {} as string,

  SHOW_HIDE_VIEW_LOP_TIN_CHI: {} as string,

  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_REQUEST: {} as any,

  SYNC_START: {} as IProcessRequest<IDongBoCongNoRequest>,
  SYNC_SUCCESS: {} as IDongBoCongNoSinhVien[],
  SYNC_ERR: {} as string,

  CLOSE_PROCESSING_MODAL: undefined,
};

export const eDongBoCongNoActionTypeIds = generateActionTypeIds(
  edongBoCongNoActionsObj,
  "DONG_BO_CONG_NO"
);
export type IDongBoCongNoActionTypes = IGenericActionType<
  typeof edongBoCongNoActionsObj,
  "DONG_BO_CONG_NO"
>;
